import ConfirmModal from '../../../components/ConfirmModal'

// Modal 3, "Delete template?" (mr-6 spec S9.2). The drawn frame shows only a Delete button -- S15
// decision 9 reads the missing Cancel as an export gap, not intent, since every other confirm/dismiss
// pair in this file has one, so it is added here. Geometry: delete-confirmation-popup, 364 x 240.
// DeleteScenarioModal.jsx reuses it for the scenario delete (README.md there).
export const DELETE_POPUP_FRAME = { minHeight: 240, padX: 32, padTop: 49, padBottom: 40, titleSize: 18, titleLeading: 22, titleGap: 13, buttonWidth: 96 }

export default function DeleteConfirmModal({ open, templateName, onConfirm, onClose, isLoading, error }) {
  return (
    <ConfirmModal
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      onCancel={onClose}
      cancelLabel="Cancel"
      isLoading={isLoading}
      error={error}
      title="Delete template?"
      body={`Delete "${templateName}"? This can't be undone.`}
      confirmLabel="Delete"
      loadingLabel="Deleting…"
      confirmClassName="bg-[#D85263] hover:bg-[#E86575]"
      width={364}
      panelBg="#F4FAEF"
      frame={DELETE_POPUP_FRAME}
    />
  )
}
